import React from 'react';

const NethraBrain = () => {
  return (
    <section className='section bg-gradient-to-br from-[#0D4645] to-[#24C9C6] text-white relative overflow-hidden'>
      <div className='container'>
        <div className='grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center'>
          <div className='text-center lg:text-left space-y-4'>
            <h2 className='text-2xl sm:text-3xl lg:text-3xl font-light text-white'>
              TRI-NETHRA — THE THIRD EYE OF DIGITAL PARENTING.
            </h2>
            <p className='text-base sm:text-lg leading-relaxed opacity-90'>
              The digital world is growing faster than ever. Children are
              exploring it earlier than ever.
            </p>
            <p className='text-base sm:text-lg leading-relaxed opacity-90'>
              Parents need more than restrictions. They need awareness,
              protection and control.
            </p>
            <p className='text-base sm:text-lg leading-relaxed opacity-90'>
              Tri-nethra is the intelligent parental-control app designed to
              help parents understand, guide and protect their children in the
              digital world — without taking away their freedom to learn,
              explore and grow.
            </p>
            <p className='text-base sm:text-lg leading-relaxed opacity-90'>
              See what matters. Protect what matters. Tri-nethra — Watch. Guide.
              Protect.
            </p>
          </div>

          <div className='flex justify-center items-center'>
            <img
              src='/assets/eye-to-face.png'
              alt='Eye to face development'
              className='w-full h-full object-contain animate-float'
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NethraBrain;
